export default __webpack_public_path__ + "static/media/Soulsplitter.5e012234.jpg";